/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Fix_HintInputs */



/**
* | output |
* | --- |
* | "Check the record, then try again once your DNS change has propagated." |
*
* @param {Canvas_Domain_Fix_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_fix_hint = /** @type {((inputs?: Canvas_Domain_Fix_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Fix_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfen Sie den Eintrag und versuchen Sie es erneut, sobald Ihre DNS-Änderung übernommen wurde.")
	return /** @type {LocalizedString} */ ("Check the record, then try again once your DNS change has propagated.")
});